import { IImageAccordion } from '@features/pages/typescript';
import styles from '@features/pages/components/PagesAccordion/components/ImageAccordion.styles';
import GetImageAlt from '@utils/getImageAlt';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
type PropsType = {
  imageAccordion: IImageAccordion;
  withMargin?: boolean;
};
const ImageAccordion = ({
  imageAccordion,
  withMargin = false
}: PropsType) => {
  const {
    images,
    alt
  } = imageAccordion;
  return <div sx={styles.frameImageBlock} data-testid="ImageAccordion">
      {images?.desktop && <ResponsiveImage image={images} alt={GetImageAlt(images) || alt} sx={styles.image(withMargin)} />}
    </div>;
};
export default ImageAccordion;